import { AlignCenter } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

const MetricCards = ({ data }) => {
  // Pull live cards data from Redux (populated by fetchVesselLocations)
  const { vesselCards } = useSelector((state) => state.rawData);

  // Redux takes priority; prop is fallback
  const cards_src = vesselCards || data || {};

  const eu_ets  = cards_src?.eu_ets  || {};
  const feum    = cards_src?.feum    || {};
  const uk_ets  = cards_src?.uk_ets  || {};
  const summary = cards_src?.summary || {};

  const formatNumber = (num, decimals = 2) => {
  if (num == null || isNaN(num)) return "-";
  return Number(num).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

const [fx, setFx] = React.useState({
  eurToUsd: null,
});

React.useEffect(() => {
  const fetchFX = async () => {
    try {
      const res = await fetch("https://open.er-api.com/v6/latest/USD");
      const data = await res.json();

      if (data.result === "success") {
        setFx({
          eurToUsd: 1 / data.rates.EUR,
        });
      }
    } catch (err) {
      console.error("FX fetch failed", err);
    }
  };

  fetchFX();
}, []);
  const cards = [
    {
      title: "EU-ETS",
      accent: "#71ade9",
      gradientFrom: "#f6f7fc",
      gradientTo: "#d5d7ec",
      metrics: [
        { label: "Cost",  value:
  eu_ets.cost != null
    ? (
        <>
          € {formatNumber(eu_ets.cost)}
          <br />
          {fx.eurToUsd && (
            <>$ {formatNumber(eu_ets.cost * fx.eurToUsd)}</>
          )}
        </>
      )
    : "-",  },
{ label: "EUA's", value: `${formatNumber(eu_ets.eua)}` },,
      ],
    },
    {
      title: "FEUM",
      accent: "#9787e9",
      gradientFrom: "#e2e0ed",
      gradientTo: "#dbd1ea",
      metrics: [
       { label: "Cost", value:
  eu_ets.cost != null
    ? (
        <>
          € {formatNumber(feum.cost)}
          <br />
          {fx.eurToUsd && (
            <>$ {formatNumber(feum.cost * fx.eurToUsd)}</>
          )}
        </>
      )
    : "-",  },

{
  label: "CB",
  value:
    feum?.cb != null
      ? ` ${formatNumber(feum.cb / 1_000_000)}T`
      : "-",
},      ],
    },
    {
      title: "UK ETS",
      accent: "#e9d7c3",
      gradientFrom: "#f3eeea",
      gradientTo: "#f5e2d1",
      metrics: [
        { label: "Cost",  value: `£ ${formatNumber(uk_ets.cost)}` },
{ label: "UKA's", value: `${formatNumber(uk_ets.uka, 0.0)}` },
      ],
    },
    {
      title: "IMO GFI",
      accent: "#dbd9ef",
      gradientFrom: "#f2effa",
      gradientTo: "#dcddf9",
      metrics: [
        { label: "T1", value: "-" },
        { label: "T2", value: "-" },
      ],
    },
    {
      title: "Summary",
      accent: "#c8dde8",
      gradientFrom: "#eef7f2",
      gradientTo: "#daeee6",
      metrics: [
        
{
  label: "Total Cost",
  value:
    summary?.total_cost != null
      ? ` $ ${formatNumber(summary.total_cost * fx.eurToUsd)} `
      : "-",
},
      ],
     
     
    },
  ];

  // (rest of the JSX is unchanged)
  return (
    <div className="metric-cards-grid">
      {cards.map((card, index) => (
        <div
          key={index}
          className="metric-card-item"
          style={{
            background: `linear-gradient(90deg, ${card.gradientFrom} , ${card.gradientTo} )`,
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            border: `1px solid ${card.gradientTo}`,
            minWidth: 0,
          }}
        >
          <h3
            className="card-title-text"
            style={{
              background: card.accent,
              color: "#444",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: 0,
              fontSize: "0.8rem",
              fontWeight: 600,
              letterSpacing: "0.3px",
              borderRadius: "10px 10px 0 0",
            }}
          >
            {card.title}
          </h3>
          <div className="card-metrics-list" style={{ padding: "8px 10px" }}>
            {card.metrics.map((metric, idx) => (
              <div
                key={idx}
                className="metric-row"
                style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "0.75rem", padding: "3px 0" }}
              >
                <span className="metric-key" style={{ color: "#555", minWidth: "48px" }}>{metric.label}</span>
                <span className="metric-arrow" style={{ color: "#aaa" }}>→</span>
                <span className="metric-val" style={{ color: "#1a1a1a", fontWeight: 500 }}>{metric.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricCards;